// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2f9vw","col":"styles_col__1HlD6"};